import React from 'react';
import { Schedule } from '@mui/icons-material';
import ProviderLogo from './ProviderLogo';
import { PAYMENT_REQUEST_VALIDITY_MINUTES } from '../../config/environment';

const STEPS = [
    { title: 'Remplissez le formulaire', text: 'Montant, réseau et numéro de compte du client.' },
    { title: 'Envoi de la demande', text: 'Une notification arrive sur le wallet du client.' },
    { title: 'Le client confirme', text: 'Il valide sur son téléphone, vous êtes notifié.' },
];

/** Colonne d'aide des demandes de paiement (admin et caissier). */
const PaymentRequestAside = ({ providers = [] }) => (
    <aside className="bg-white rounded-2xl border border-slate-200/80 shadow-sm overflow-hidden xl:sticky xl:top-6">
        {/* Étapes */}
        <div className="p-5">
            <h3 className="text-base font-semibold text-slate-800">Comment ça marche</h3>
            <ol className="mt-4 space-y-4">
                {STEPS.map((step, i) => (
                    <li key={step.title} className="flex gap-3">
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-500 text-xs font-bold text-white">
                            {i + 1}
                        </span>
                        <div className="min-w-0">
                            <p className="text-sm font-medium text-slate-800">{step.title}</p>
                            <p className="text-xs text-slate-500 mt-0.5">{step.text}</p>
                        </div>
                    </li>
                ))}
            </ol>
        </div>

        {/* Validité */}
        <div className="mx-5 mb-5 flex items-start gap-3 rounded-xl bg-amber-50 border border-amber-200/80 px-4 py-3">
            <Schedule className="text-amber-600 shrink-0" fontSize="small" />
            <p className="text-xs text-slate-700">
                Chaque demande est valable <strong>{PAYMENT_REQUEST_VALIDITY_MINUTES} minutes</strong>. Passé ce délai, elle expire et il faut en créer une nouvelle.
            </p>
        </div>

        {/* Réseaux acceptés */}
        <div className="border-t border-slate-100 p-5">
            <div className="flex items-baseline justify-between gap-2">
                <h3 className="text-base font-semibold text-slate-800">Réseaux acceptés</h3>
                <span className="text-xs text-slate-500">Mobile Money & Netikash Pay</span>
            </div>
            {providers.length > 0 ? (
                <ul className="mt-4 grid grid-cols-2 gap-2">
                    {providers.map((p) => (
                        <li key={p.id} className="flex items-center gap-2.5 min-w-0 rounded-xl border border-slate-200/80 bg-slate-50 px-2.5 py-2">
                            <ProviderLogo provider={p} className="w-8 h-8 rounded-lg" />
                            <span className="text-xs font-medium text-slate-700 truncate">{p.name}</span>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="mt-3 text-xs text-slate-500">Chargement des réseaux…</p>
            )}
        </div>
    </aside>
);

export default PaymentRequestAside;
